import { IColumnChartProps } from './types'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { defaultOptions } from './defaultOptions'
import styles from './styles.module.scss'
import getChartOptions from '../chartOptionsMerge'

const LineChart = ({ ...props }: IColumnChartProps) => {
  return (
    <div className={styles.chartHolder}>
      <HighchartsReact highcharts={Highcharts} options={getChartOptions(defaultOptions, props)} />
    </div>
  )
}

export default LineChart
